export default function(requestFn) {
    const headers = $.ajaxSettings.headers;
    delete $.ajaxSettings.headers;
    const promise = requestFn();
    $.ajaxSettings.headers = headers;
    return promise;
}
